import { render, staticRenderFns } from "./AvatarNameModal.vue?vue&type=template&id=21ec6b12&scoped=true&"
import script from "./AvatarNameModal.vue?vue&type=script&lang=js&"
export * from "./AvatarNameModal.vue?vue&type=script&lang=js&"
import style0 from "./AvatarNameModal.vue?vue&type=style&index=0&id=21ec6b12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec6b12",
  null
  
)

export default component.exports